// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select_selectField__o6p1s {
  padding-right: 44px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.Select_icon__kF2-w {
  position: absolute;
  right: 16px !important;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  transition: 0.2s all;
}
.Select_iconBody__UrS7t {
  transform: rotate(180deg);
}
.Select_popper__6h9jV {
  z-index: 9999;
}

.Select_paper__KnD6n {
  background: white;
  width: 100%;
}

.Select_item__bS8xF {
  height: 40px;
  display: flex !important;
  width: 100%;
  font-weight: 400;
  font-size: 14px !important;
  color: #272A36;
  padding: 12px 52px 12px 12px !important;
  background: white !important;
  border: 0;
  outline: none;
  text-align: left;
  transition: 0.2s all;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.Select_item__check__jGug1 {
  opacity: 0;
  position: absolute;
  right: 13px;
}
@media (hover: hover) {
  .Select_item__bS8xF:hover {
    background: #F7F7F7 !important;
  }
  .Select_item__bS8xF:hover .Select_item__check__jGug1 {
    transition: 0.2s all;
    opacity: 1;
  }
  .Select_item__bS8xF:hover .Select_item__check__jGug1 path {
    fill: #8E8E93;
  }
}
.Select_item__bS8xF[aria-selected=true] {
  font-weight: 600;
}
.Select_item__bS8xF[aria-selected=true] .Select_item__check__jGug1 {
  display: inline-block;
  opacity: 1;
}
.Select_item__bS8xF[aria-selected=true] .Select_item__check__jGug1 path {
  fill: #4778EE !important;
}

.Select_menu__4d1i2 {
  transform: translateY(2px) !important;
  box-shadow: none !important;
  border: 1px solid #4778EE;
  border-radius: 4px;
  background: white;
}
.Select_menu__list__-fynh {
  padding: 0 !important;
}

.Select_value__js7-r {
  color: #272A36;
  font-weight: 400;
  font-size: 14px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.Select_value__placeholder__Tymke {
  font-weight: 400;
  font-size: 14px;
  color: #8E8E93;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/fields/Select/Select.module.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,2BAAA;EACA,8BAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;EAGA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;AADF;AAGE;EACE,yBAAA;AADJ;AASA;EACE,aAAA;AAPF;;AAUA;EACE,iBAAA;EACA,WAAA;AAPF;;AAUA;EACE,YAAA;EACA,wBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;EACA,uCAAA;EACA,4BAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAPF;AASE;EACE,UAAA;EACA,kBAAA;EAGA,WAAA;AATJ;AAaE;EACE;IACE,8BAAA;EAXJ;EAaI;IACE,oBAAA;IACA,UAAA;EAXN;EAaM;IACE,aAAA;EAXR;AACF;AAgBE;EAUE,gBAAA;AAvBJ;AAcI;EACE,qBAAA;EACA,UAAA;AAZN;AAcM;EACE,wBAAA;AAZR;;AAoBA;EACE,qCAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAjBF;AAmBE;EACE,qBAAA;AAjBJ;;AAqBA;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAlBF;AAoBE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAlBJ","sourcesContent":[".selectField {\n  padding-right: 44px !important;\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n\n.icon {\n  position: absolute;\n  right: 16px !important;\n  pointer-events: none;\n  user-select: none;\n  //transform: rotate(0deg) translateY(-50%);\n  //top: 50% !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1em;\n  height: 1em;\n  transition: 0.2s all;\n\n  &Body {\n    transform: rotate(180deg);\n  }\n\n  &Open {\n    //transform: rotate(-180deg) translateY(-50%) !important;\n  }\n}\n\n.popper {\n  z-index: 9999;\n}\n\n.paper {\n  background: white;\n  width: 100%;\n}\n\n.item {\n  height: 40px;\n  display: flex !important;\n  width: 100%;\n  font-weight: 400;\n  font-size: 14px !important;\n  color: #272A36;\n  padding: 12px 52px 12px 12px !important;\n  background: white !important;\n  border: 0;\n  outline: none;\n  text-align: left;\n  transition: 0.2s all;\n  cursor: pointer;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n\n  &__check {\n    opacity: 0;\n    position: absolute;\n    //float: right;\n    //margin-left: auto;\n    right: 13px;\n  }\n\n  // enable hover only for desktops\n  @media (hover: hover) {\n    &:hover {\n      background: #F7F7F7 !important;\n\n      .item__check {\n        transition: 0.2s all;\n        opacity: 1;\n\n        path {\n          fill: #8E8E93;\n        }\n      }\n    }\n  }\n\n  &[aria-selected=\"true\"] {\n    .item__check {\n      display: inline-block;\n      opacity: 1;\n\n      path {\n        fill: #4778EE !important;\n      }\n    }\n\n    font-weight: 600;\n  }\n}\n\n.menu {\n  transform: translateY(2px) !important;\n  box-shadow: none !important;\n  border: 1px solid #4778EE;\n  border-radius: 4px;\n  background: white;\n\n  &__list {\n    padding: 0 !important;\n  }\n}\n\n.value {\n  color: #272A36;\n  font-weight: 400;\n  font-size: 14px !important;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  &__placeholder {\n    font-weight: 400;\n    font-size: 14px;\n    color: #8E8E93;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectField": `Select_selectField__o6p1s`,
	"icon": `Select_icon__kF2-w`,
	"iconBody": `Select_iconBody__UrS7t`,
	"popper": `Select_popper__6h9jV`,
	"paper": `Select_paper__KnD6n`,
	"item": `Select_item__bS8xF`,
	"item__check": `Select_item__check__jGug1`,
	"menu": `Select_menu__4d1i2`,
	"menu__list": `Select_menu__list__-fynh`,
	"value": `Select_value__js7-r`,
	"value__placeholder": `Select_value__placeholder__Tymke`
};
export default ___CSS_LOADER_EXPORT___;
